import useSWR from 'swr';
import { API_HOST } from '../helpers/constants';
import { fetcher } from '../utils';

export function useFaq(id) {
  const url = `${API_HOST}/faqs/${id}`;

  const { data: responseData, error, isLoading, mutate } = useSWR(id ? url : null, fetcher);

  const revalidate = () => mutate(url);

  return {
    faq: responseData,
    isLoading,
    isError: error,
    revalidate
  };
}
